import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=21067488&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21067488",
  null
  
)

export default component.exports